import { ProvenDevelopedProducingDatasetBase } from './base/proven-developed-producing-dataset-base';

export class ProvenDevelopedProducingDataset extends ProvenDevelopedProducingDatasetBase { }